import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { MyoderService } from '../shared/myoder.service';
import { Order } from '../../models/orders.model';
import { Sort } from '@angular/material/sort';
import { TablefilterMultiplePipe } from '../../shared/pipes/tablefilter-multiple.pipe';
import { FileService } from '../../services/file.service';
import { ManageService } from '../../services/manage.service';
import { NgProgressService } from '../../services/ngProgress.service';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-search-orders',
    templateUrl: './search-orders.component.html',
    styleUrls: ['./search-orders.component.css']
})
export class SearchOrdersComponent implements OnInit {

    title = 'Search Orders';

    searchField: string;
    hasEmptyResult: boolean = true;
    hasEmptyFilterResult: boolean = false;
    filterResultArr: any;
    completeSearch: boolean = false;
    sortedData: Order[];
    orders: Order[];
    loadContent: boolean;
    filterInput: string = '';
    
    constructor(
        private orderService: MyoderService,
        private activeRouter: ActivatedRoute,
        private manageService: ManageService,
        public ngProgress: NgProgressService,
        private fileService: FileService,
        private router: Router
    ) { }

    ngOnInit() {
        this.activeRouter.paramMap.subscribe(s => {
            const searchValue = s.get('searchparm');
            if (searchValue) {
                this.loadContent = false;
                this.filterReset();
                this.hasEmptyResult = true;
                this.completeSearch = false;
                this.orderService.getShippedOrders(searchValue.trim()).subscribe((res: Order[]) => {
                    this.completeSearch = true;
                    if (res && res.length) {
                        this.orders = res;
                        this.sortedData = this.orders.slice();
                        this.hasEmptyResult = false;
                    } else {
                        this.hasEmptyResult = true;
                    }
                    this.searchField = "";
                    this.loadContent = true;
                },
                    (error: any) => {
                        this.completeSearch = true;
                        this.loadContent = true;
                        console.error(error);
                    });
            }
        }
        );

        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
            var routeArr = this.router.url.split("/");
            if (this.router.url.includes('/myOrder/searchorders') && routeArr.length == 4) {
              $('#levelOne').animate({ scrollLeft: -250 }, 400);
            } 
        });
    }

    sortData(sort: Sort) {
        const data = this.orders.slice();
        if (!sort.active || sort.direction == '') {
            this.sortedData = data;
            return;
        }

        this.sortedData = data.sort((a, b) => {
            let isAsc = sort.direction == 'asc';
            switch (sort.active) {
                case 'invoiveNo': return compare(a.orderNo, b.orderNo, isAsc);
                case 'invoiceDate': return compare(a.dateInvoiced.split('-').reverse().join('-'), b.dateInvoiced.split('-').reverse().join('-'), isAsc);
                case 'resellerPO': return compare(a.resellerPO, b.resellerPO, isAsc);
                case 'totalEx': return compare(parseFloat(a.totalEx), parseFloat(b.totalEx), isAsc);
                default: return 0;
            }
        });
    }

    onChange() {
        this.filterResultArr = new TablefilterMultiplePipe().transform(
            this.orders, ['orderNo', 'dateInvoiced', 'resellerPO', 'courier', 'connote'], this.searchField);

        if (this.filterResultArr.length === 0) {
            this.hasEmptyFilterResult = true;

        } else {
            this.hasEmptyFilterResult = false;
        }
    }

    ExportSearchedOrder(): void {
        this.ngProgress.start();
        this.manageService.ExportInvoicedOrder(this.sortedData, true).subscribe((data: any) => {
            this.ngProgress.done();
            const fileName = `Searched Order.xlsx`;
            this.fileService.saveAsExcelFile(data, fileName);
        },
            (error: any) => {
                console.info(error);
                this.loadContent = true;
            });
    }

    filterReset() {
        this.searchField = '';
        this.hasEmptyFilterResult = false;
    }

    exportOrderSerials(orderNumber: string, orderSuffix: string) {
        this.orderService.exportExportOrderSerials(orderNumber, orderSuffix)
            .subscribe(data => {
                const fileName = `DD_OrderSerials_${orderNumber}.xlsx`;
                this.fileService.saveAsExcelFile(data, fileName);
            },
                (error: any) => {
                    console.info(error);
                });
    }

    onLoading(currentLoadingStatus: boolean) {
        this.loadContent = !currentLoadingStatus;
    }

    convertTotal(total: string) {
        if (total.includes('-')) {
            return `-$${total.replace('-', '')}`;
        } else {
            return '$' + total;
        }
    }
    close() {
        this.router.navigateByUrl('/myOrder');
        $('#levelOne').animate(
            { scrollLeft: (-252) },
            {
              duration: 400,
              complete: function () {
                $('.combination-loader').stop(true, false);
              }
        });
    }
}

function compare(a, b, isAsc) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
